module.exports = {
    ROOT_PATH: '/app'
};